import React from "react";
import ReactSelect from "react-select-async-paginate";
import { SelectBody } from "./selectBody";

export const SelectAsync = ({ ...props }) => {
	return <SelectBody component={ReactSelect} {...props} />;
};
